import IconButton from "@material-ui/core/IconButton";
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import React from "react";
import clsx from 'clsx';
import {makeStyles, useMediaQuery} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    menuButton: {
        marginRight: '36px',
        display: 'block',
    },
}));

export const ToggleSideBarButton = (props: any) => {
    const classes = useStyles();
    const { drawerIsOpen, toggleDrawerClicked} = props;

       const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

    const toggleSideBarButton = isMobile ? (
               <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawerClicked}
            className={clsx(classes.menuButton)}>
                        {drawerIsOpen ? (<CloseIcon/>) : (<MenuIcon/>)}
        </IconButton>
    ) : null;
    return toggleSideBarButton;
};
